import React from "react";

const TextBox2 = ({
  label,
  name,
  placeholder,
  credentials,
  value,
  setValue,
  type,
  readOnly,
  disabled
}) => {
  const handleInputs = (e) => {
    // Setting name and values dynamically
    setValue({ ...credentials, [e.target.name]: e.target.value });
    // console.log(credentials.descriptio);
  };

  const isReadOnly = readOnly || disabled;
  const inputBase =
    "w-full rounded-xl border outline-none transition-all duration-200 text-gray-900 placeholder-gray-400";
  const inputReadOnly =
    "bg-gray-50 border-gray-200/60 py-3 px-4 cursor-default";
  const inputEditable =
    "bg-white/80 backdrop-blur-sm border-gray-200/60 py-3 px-4 focus:ring-2 focus:ring-primary-500/30 focus:border-primary-500";

  return (
    <div className="w-full text-left">
      <label className="text-sm font-medium text-gray-700 block mb-1.5" htmlFor={name}>
        {label}
      </label>
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleInputs}
        className={`${inputBase} ${isReadOnly ? inputReadOnly : inputEditable}`}
        readOnly={readOnly}
        disabled={disabled}
        style={{ cursor: disabled ? "not-allowed" : isReadOnly ? "default" : "text" }}
      />
    </div>
  );
};

export default TextBox2;
